import React from "react";
import "./StyleSheet.css";
import {DefaultParameters} from "../../Api/ApiCallMethod";

export default class WhyIPAgentAI extends React.Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    login = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');

    }

    render() {
        return (
            <div className="article-layout">
                <p>
                    Donald (name changed), Head of IP at a Fortune 100 company, told me, “I wanted to meet you in person because I didn’t believe our vendor could build AI.” I was meeting with him at the request of another company, as he had specifically asked for the discussion.
                </p>
                <p>
                    Donald elaborated on the evolution of the IP industry, explaining how service vendors have transformed into software vendors and highlighting the industry’s significant lack of adequate tools. He emphasized how underserved the sector remains and how IP professionals struggle with inefficient processes, diverting their focus from intellectual work to mundane tasks.
                </p>
                <p>
                    As I listened, I reflected on the ongoing shortage of IP professionals—if they are forced to spend time on non-IP tasks, it only exacerbates the problem. I was also struck by the irony of an industry still underserved in the era of AI. This realization led to the creation of <b>IP Agent AI</b>, the first <b>agentic AI platform</b> designed specifically for IP professionals. Our AI Agents take over routine, repetitive tasks, allowing experts to focus on the intellectual aspects of their profession. <b>IP Agent AI</b> is built to empower IP professionals, enhancing productivity while making their work more engaging and enjoyable, ultimately delivering <b>unparalleled value</b> to enterprises and law firms.
                </p>
                <p>
                    <span className="article-layout-link" onClick={this.login.bind(this)}>Click here</span> to get started, if you have any questions or have any feedback I can be reached at <a href="mailto: suresh@anygen.ai">
                    suresh@anygen.ai.</a>
                </p>
            </div>
        );
    }



}


